import { ReactNode } from 'react';
import { useAuthStore } from '../../../stores/authStore';
import { SSOLoginButton } from './SSOLoginButton';

interface ProtectedRouteProps {
  children: ReactNode;
  showLayout?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, showLayout = false }) => {
  const { isAuthenticated, loading } = useAuthStore();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-center">
          <div className="mb-4 inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-[var(--color-primary-500)] border-r-transparent"></div>
          <p className="text-[var(--color-text-primary)]">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    const currentPath = window.location.pathname;
    if (currentPath !== '/') {
      localStorage.setItem('sso_redirect_to', currentPath);
    }

    if (showLayout) {
      return (
        <>
          {children}
        </>
      );
    }

    return (
      <div className="flex min-h-screen items-center justify-center" style={{ backgroundColor: 'var(--color-background-default)' }}>
        <div className="text-center max-w-md mx-auto px-4">
          <h1 className="text-2xl font-bold mb-4" style={{ color: 'var(--color-text-primary)' }}>
            Please sign in to continue
          </h1>
          <p className="mb-6 text-sm" style={{ color: 'var(--color-text-secondary)' }}>
            You need to be authenticated to access this page.
          </p>
          <SSOLoginButton variant="primary" size="md" />
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

